import getPageType, { PageType, PageTypeOptions } from '@spa/lib/tracking/getPageType';
import pushToDataLayer, {
  SearchSuggestionType,
  TrackingEvent,
  TrackingSelectSearchSuggestionEvent
} from '@spa/lib/tracking/pushToDataLayer';

export const trackSelectSearchSuggestionActions = (
  searchSuggestionName: string,
  searchSuggestionQuery: string,
  searchSuggestionType: SearchSuggestionType,
  pageTypeOptions: PageTypeOptions
): void => {
  const pageType: PageType = getPageType(pageTypeOptions);

  const selectSearchSuggestionEvent: TrackingSelectSearchSuggestionEvent = {
    event: TrackingEvent.SELECT_SEARCH_SUGGESTION,
    search_suggestion_name: searchSuggestionName,
    search_suggestion_query: searchSuggestionQuery,
    search_suggestion_type: searchSuggestionType,
    page_type: pageType
  };

  pushToDataLayer(selectSearchSuggestionEvent);
};

export default trackSelectSearchSuggestionActions;
